import { ActionRow, ADMIN_TAG, SettingsCard, ToggleRow } from '../SettingsKit'

// Sample LLM prompts for the prompts table wireframe.
const PROMPTS = [
    { name: 'Brand-safe replies', updated: '3 days ago' },
    { name: 'Escalation triage', updated: '2 weeks ago' }
]

export default function AiRepliesTab() {
    return (
        <>
            <SettingsCard title="Classification" badges={ADMIN_TAG}>
                <ToggleRow
                    label="LLM classification"
                    description="Use an LLM to classify content for this profile."
                    defaultOn
                />
                <div className="py-3">
                    <div className="mb-2 flex items-center justify-between">
                        <span className="text-xs font-semibold text-gray-800">Prompts</span>
                        <button
                            type="button"
                            className="rounded border border-dashed border-arwen-300 px-2.5 py-1 text-xs font-semibold text-arwen-700"
                        >
                            + Create prompt
                        </button>
                    </div>
                    <table className="w-full border-collapse text-sm">
                        <tbody className="divide-y divide-gray-50">
                            {PROMPTS.map((p) => (
                                <tr key={p.name}>
                                    <td className="py-2 font-medium text-gray-800">{p.name}</td>
                                    <td className="py-2 text-right text-xs text-gray-800">
                                        Updated {p.updated}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </SettingsCard>

            <SettingsCard title="Replies" badges={ADMIN_TAG}>
                <ToggleRow
                    label="LLM suggested replies"
                    description="Generate suggested replies to comments with an LLM."
                />
                <ActionRow
                    label="LLM reply settings"
                    description="Tone, guardrails and signature for generated replies."
                    action="Open"
                />
            </SettingsCard>
        </>
    )
}
